export default "__VITE_ASSET__778a00ff__"